import React from 'react'

import { PlusOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useOperatorData } from '@contexts/operator/OperatorDataContext'
import { useIsStandard } from '@contexts/operator/PlanContext'
import ListPageHeader from '@shared/ListPageHeader'
import BrandsList from '@shared/brands/BrandsList'
import Can from '@shared/permissions/Can'

import brandService from '@services/operator/brandService'

const OperatorBrandsList: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { merchants } = useOperatorData() as { merchants: Array<{ id: string; name: string }> }
  const isStandard = useIsStandard()

  return (
    <div>
      <ListPageHeader
        items={['products', 'products.brands']}
        actions={
          <Can requiredPermission="brands:write">
            <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/brands/new')}>
              {t('common.button.new')}
            </Button>
          </Can>
        }
      />
      <BrandsList
        service={brandService}
        role="operator"
        showMerchantColumn={!isStandard}
        merchants={merchants}
      />
    </div>
  )
}

export default OperatorBrandsList
